import { Injectable } from '@angular/core';
import {
  ExternalpageService,
  externalpageTypes,
  externalpageImageTypes,
  externalpageStatuses
} from './externalpage.service';
import {Subject, Subscription} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {DomainService} from './domain.service';
import {TargetGroupService} from './target-group.service';

/**
 * @deprecated Use `ExternalPageService` from
 * `src/app/api/services/external-page.service.ts` together with
 * `DomainService.getCurrentRegion()` and
 * `TargetGroupService.getDefaultTargetGroups$('externalpage')`.
 *
 * This wrapper is an untyped façade around an older version of the
 * External Page API and will be removed once all remaining callers
 * (home-events-section, page-events, page-i-am-a-student,
 * page-i-am-a-company, page-event) have migrated. See
 * `app-events-list-card` for a reference implementation.
 */
@Injectable({
  providedIn: 'root'
})
export class EventService {

  externalpageTypes = externalpageTypes;
  externalpageImageTypes = externalpageImageTypes;

  public homeData: any[] = [];
  public $homeDataSubject: Subject<any> = new Subject();

  constructor(
    public externalpageService: ExternalpageService,
    private domain: DomainService,
    private targetGroupService: TargetGroupService
  ) {

  }

  /**
   * Get home data
   * @deprecated See class-level deprecation notice.
   */
  getHomeData() {

    return this.homeData;

  }

  /**
   * Set home data
   * @deprecated See class-level deprecation notice.
   */
  setHomeData()
  {
    if (this.homeData?.length == 0) {

      const $queryParams = {
        pageNumber: 1,
        pageSize: 100,
        PageStatus: externalpageStatuses.Published,
      };

      this.targetGroupService.getDefaultTargetGroups$('externalpage').pipe(
        switchMap(targetGroups => {
          const targetGroup = targetGroups?.[0] ?? null;
          return this.externalpageService.apiGetExternalPageType(this.externalpageTypes.Event, $queryParams, this.domain.getCurrentRegion(), targetGroup);
        })
      ).subscribe( (result: any) => {
        if (result && result.hasOwnProperty('data')) {
          this.homeData = Object.assign([], result.data);
          this.homeData = this.getEventGroup(this.homeData);

          if (this.homeData?.length > 0) {

            // Get all images of projects
            for (const i in this.homeData) {
              this.homeData[i]['imageUri'] = '';

              if (this.homeData[i]['imageReferences']?.length > 0) {
                for (const image of this.homeData[i]['imageReferences']) {
                  if (image['imageType'] == this.externalpageImageTypes.MainImage) {
                    this.homeData[i]['imageUri'] = image['imageUri'];
                  }
                }
              }
            }

            this.$homeDataSubject.next(true);

          } else {
            this.$homeDataSubject.next(true);
          }
        }
      });
    }
  }


  /** @deprecated See class-level deprecation notice. */
  getEventGroup(events: any[], newOnly = true): any
  {
    if (events?.length === 0) {
      return;
    }

    const currentDate: Date = new Date();
    const result: any[] = [];

    events = events.sort((a: any, b: any) => {
      const dateA: Date = new Date(a.eventDate);
      const dateB: Date = new Date(b.eventDate);

      // Difference from current date
      const diffA: number = Math.abs(dateA.getTime() - currentDate.getTime());
      const diffB: number = Math.abs(dateB.getTime() - currentDate.getTime());

      return diffA - diffB;
    });

    for (let event of events) {
      let eventDate = new Date(event.eventDate);
      if (newOnly) {
        if (eventDate.getTime() >= currentDate.getTime()) {
          result.push(event);
        }
      } else {
        if (eventDate.getTime() <= currentDate.getTime()) {
          result.push(event);
        }
      }

    }
    return result;
  }

  /** @deprecated See class-level deprecation notice. */
  groupEvents(events: any[]) {

    const result = {
      new: [],
      old: [],
    };

    result.new = this.getEventGroup(events, true);
    result.old = this.getEventGroup(events, false);
    return result;
  }

}
